import { EntityMetadata } from "@/models/EntityMetadata";

export class RequestSalvaDatiAggiuntiviOrdine
{
    public idOrdine?: string;

    public datiAggiuntivi?: EntityMetadata[];    
}